/**
 * Front-end script for block-contacts.
 * Handles phone input masking on the feedback form.
 */

function formatPhone(value) {
	const digits = value.replace(/\D/g, '');

	let formatted = '+7';
	let rest = '';

	if (digits.startsWith('7') || digits.startsWith('8')) {
		rest = digits.slice(1);
	} else {
		rest = digits;
	}

	rest = rest.slice(0, 10);

	if (rest.length > 0) {
		formatted += ' (' + rest.slice(0, 3);
	}
	if (rest.length > 3) {
		formatted += ') ' + rest.slice(3, 6);
	}
	if (rest.length > 6) {
		formatted += ' ' + rest.slice(6, 8);
	}
	if (rest.length > 8) {
		formatted += ' ' + rest.slice(8, 10);
	}

	return formatted;
}

document.addEventListener('DOMContentLoaded', function () {
	const phoneInputs = document.querySelectorAll('.block-contacts .form-phone');

	phoneInputs.forEach(function (input) {
		input.addEventListener('input', function (e) {
			const cursorPos = e.target.selectionStart;
			const prevLength = e.target.value.length;
			const formatted = formatPhone(e.target.value);
			e.target.value = formatted;

			// Adjust cursor position
			const newLength = formatted.length;
			const diff = newLength - prevLength;
			e.target.setSelectionRange(cursorPos + diff, cursorPos + diff);
		});
	});
});
